export const gradients = {
  // Уникальные и осмысленные градиенты
  backgroundGradientTailwind: "bg-gradient-to-b from-[#0A2A45] to-[#061C2F]", // используется для общего фона
  backgroundDarkBlue: "bg-gradient-to-b from-primaryVariant to-primary", // основной тёмный фон
  buttonGradient: "bg-gradient-to-br from-emerald2 to-emerald", // основной градиент для кнопок
  buttonGradientHover: "hover:from-emerald hover:to-emerald2", // hover для кнопок
  cardStatusBarColor: "bg-gradient-to-bl from-[#0A2A45] to-[#061C2F]", // статусбар карты (не совпадает с другими)
  cardStatusBarColorAvailable: "bg-gradient-to-bl from-emerald to-emerald2", // статусбар карты (активный)

  // Дополнительные красивые градиенты
  primaryGradient: "bg-gradient-to-r from-primaryVariant to-primary",
  turquoiseGradient: "bg-gradient-to-r from-turquoise2 to-turquoise",
  emeraldGradient: "bg-gradient-to-br from-emerald to-emerald2",
  roseGradient: "bg-gradient-to-br from-darkRose to-rose",
  blueGradient: "bg-gradient-to-b from-blue4 to-blue2",
}; 
